import { LANGUAGE } from '../constants';
import { Language } from '../types/common';
import type { OptionsType } from '../types/options';

interface Options {
  tradingCompanies?: OptionsType[];
  language?: Language;
}

const defaultOption: Options = {
  tradingCompanies: undefined,
  language: undefined,
};

/**
 * 商社コードから商社名を返す。該当する商社が見つからなかったら空文字を返す。
 * @param tradingCompanyCode [string]
 * @param option [Options]
 * @returns [string]
 */
const getTradingCompanyName = (tradingCompanyCode: string, option: Options = {}): string => {
  const mergedOption: Options = { ...defaultOption, ...option };
  const { tradingCompanies, language } = mergedOption;
  // 商社の検索
  const tradingCompany: OptionsType | undefined = tradingCompanies?.find((company) => company.code === tradingCompanyCode);
  const tradingCompanyName: string = tradingCompany
    ? language
      ? language === LANGUAGE.EN
        ? tradingCompany.nameEnglish
          ? tradingCompany.nameEnglish
          : tradingCompany.nameJapanese
        : tradingCompany.nameJapanese
      : tradingCompany.nameJapanese
    : '';
  return tradingCompanyName;
};

export default getTradingCompanyName;
